import React from 'react'

import { DealNote } from './DealNoteItem'
import { useDealNotesTemplates } from './useDealNotesTemplates'
import { useScrollPosMemory } from '@/features/SidePanel/useScrollPosMemory'
import { useCurrentApplication } from '@/graphql/services/application'
import { useListNotesQuery } from '@/services/notes'

export function DealNotes() {
  const { data: application } = useCurrentApplication()

  const {
    data: dealNotes,
    isLoading,
    isFetching,
    isSuccess,
  } = useListNotesQuery(application?.externalId, { skip: !application?.externalId })

  const salesReviewNote = dealNotes?.results.find((n) => n.type === 'sales_commentary')
  const initialUWReviewNote = dealNotes?.results.find((n) => n.type === 'initial_uw_commentary')
  const valuationsReviewNote = dealNotes?.results.find((n) => n.type === 'valuations_review')
  const finalUWReviewNote = dealNotes?.results.find((n) => n.type === 'final_uw_commentary')
  const uamFinalReviewNote = dealNotes?.results.find((n) => n.type === 'uam_final_commentary')
  const initialReviewNote = dealNotes?.results.find((n) => n.type === 'initial_review')
  const finalSubmissionReviewNote = dealNotes?.results.find(
    (n) => n.type === 'final_submission_review'
  )
  const uwFinalReviewNote = dealNotes?.results.find((n) => n.type === 'uw_final_review')

  const { templates } = useDealNotesTemplates(application, dealNotes)

  const dealNotesKeyNamespace = `unlock:max:app:${application?.externalId}:sidePanel:dealNotes`
  const scrollPositionKey = `${dealNotesKeyNamespace}:scroll`
  useScrollPosMemory(scrollPositionKey)

  return (
    <>
      {isFetching && <p>Loading...</p>}
      {(!isFetching || !isLoading) && isSuccess && (
        <ul className='flex flex-col gap-y-5 p-1'>
          <DealNote
            title='Sales Review'
            dealNote={{
              application: application?.id,
              ...salesReviewNote,
              type: 'sales_commentary',
            }}
            template={templates?.sales_commentary}
            userDraftKey={`${dealNotesKeyNamespace}:salesCommentary`}
          />
          <DealNote
            title='Initial Review'
            dealNote={{
              application: application?.id,
              ...(initialReviewNote ? initialReviewNote : initialUWReviewNote),
              type: 'initial_review',
            }}
            template={templates?.initial_uw_commentary}
            userDraftKey={`${dealNotesKeyNamespace}:initialUWcommentary`}
          />
          <DealNote
            title='Valuations Review'
            dealNote={{
              application: application?.id,
              ...valuationsReviewNote,
              type: 'valuations_review',
            }}
            template={templates?.valuations_review}
            userDraftKey={`${dealNotesKeyNamespace}:valuationsReview`}
          />
          <DealNote
            title='Final Submission Review'
            dealNote={{
              application: application?.id,
              ...(finalSubmissionReviewNote ? finalSubmissionReviewNote : finalUWReviewNote),
              type: 'final_submission_review',
            }}
            template={templates?.final_uw_commentary}
            userDraftKey={`${dealNotesKeyNamespace}:finalUWcommentary`}
          />
          <DealNote
            title='UW Final Review'
            dealNote={{
              application: application?.id,
              ...(uwFinalReviewNote ? uwFinalReviewNote : uamFinalReviewNote),
              type: 'uw_final_review',
            }}
            userDraftKey={`${dealNotesKeyNamespace}:uamFinalCommentary`}
          />
        </ul>
      )}
    </>
  )
}
